import React from 'react';
import {
  Stack,
  Alert,
  AlertTitle,
  Skeleton,
} from '@mui/material';
import {
  TripMatchDetailCard,
} from '@marageti/z4-lib';
import { ApiError } from '@marageti/z4-sdk/lib/tracking';
import { Traveler } from '@marageti/z4-sdk/lib/people';
import { TripMatch, TripRequest } from '@marageti/z4-sdk/lib/travel';
import { getChipsFromTripMatch } from '../../../utils/chips';
import { shouldShowSalesCard } from '../../../utils/trip-matches';
import TripMatchSalesCard from '../../trip-match-sales';
import TravelerCard from '../../traveler-card';
import TravelerProfileNotesSection from '../../traveler-profile-notes';
import TripRequestMatchingNotes from '../../trip-request-matching-notes';

type TripMatchMessageSidebarViewProps = {
  error: ApiError | null;
  travelers: Traveler[] | undefined;
  travelerId: string | undefined;
  tripMatch: TripMatch | undefined;
  tripRequest: TripRequest | undefined;
  onEditSuccess: () => void;
};

const TripMatchMessageSidebarView = ({
  error,
  travelers,
  travelerId,
  tripMatch,
  tripRequest,
  onEditSuccess,
}: TripMatchMessageSidebarViewProps) => (
  <Stack spacing={2}>
    {error && (
      <Alert severity="error">
        <AlertTitle>
          There was an error loading information
        </AlertTitle>
        {error.message}
        {error.code && ` Code: ${error.code} `}
        {error.id && ` ID: ${error.id}`}
      </Alert>
    )}
    <TravelerCard
      travelers={travelers || []}
      tripRequest={tripRequest}
      onEditProfile={onEditSuccess}
      onEditEmail={onEditSuccess}
    />
    {tripMatch && (
      <TripMatchDetailCard
        chips={getChipsFromTripMatch(tripMatch, true)}
        tripMatch={tripMatch}
        title="Match Details"
      />
    )}
    {tripMatch && shouldShowSalesCard(tripMatch) && (
      <TripMatchSalesCard tripMatch={tripMatch} />
    )}
    {travelerId ? (
      <TravelerProfileNotesSection travelerId={travelerId} />
    ) : (
      <Skeleton variant="rounded" height={160} />
    )}
    {tripRequest?.matchingNotes && Object.keys(tripRequest.matchingNotes).length > 0 && (
      <TripRequestMatchingNotes
        tripRequest={tripRequest}
        onEditSuccess={onEditSuccess}
      />
    )}
  </Stack>
);

export default TripMatchMessageSidebarView;
